import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
export var FETCH_ERROR_NAME = 'FetchError';
export var FetchError = /*#__PURE__*/function (_Error) {
  _inherits(FetchError, _Error);
  var _super = _createSuper(FetchError);
  function FetchError(message, status) {
    var _this;
    _classCallCheck(this, FetchError);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "name", FETCH_ERROR_NAME);
    _this.status = status;
    return _this;
  }
  _createClass(FetchError, null, [{
    key: "isFetchError",
    value: function isFetchError(value) {
      if (process.env.NODE_ENV === 'testing') {
        // jest messes up globals badly, see https://github.com/facebook/jest/issues/2549
        // once that issue is fixed, the usages of this function can be inlined to `error instanceof BadStatusError`
        return (value === null || value === void 0 ? void 0 : value.name) === FETCH_ERROR_NAME;
      }
      return value instanceof FetchError;
    }
  }]);
  return FetchError;
}( /*#__PURE__*/_wrapNativeSuper(Error));